import React, { type ReactNode } from 'react';
import { BUILDER_PANE_APP, BUILDER_PANE_CHAT, BUILDER_PANE_DETAILS, type BuilderPane } from './builderWorkspace.constants';
import { CanvasPane, ChatPane, LayoutRow, RailPane } from './BuilderLayout.styled';

interface BuilderLayoutProps {
  readonly railOpen: boolean;
  readonly chatOpen: boolean;
  readonly phonePane: BuilderPane;
  readonly rail: ReactNode;
  readonly canvas: ReactNode;
  readonly chat: ReactNode;
}

const BuilderLayout: React.FC<BuilderLayoutProps> = ({ railOpen, chatOpen, phonePane, rail, canvas, chat }) => (
  <LayoutRow data-testid="app-builder__layout">
    <RailPane
      $open={railOpen}
      $phoneActive={phonePane === BUILDER_PANE_DETAILS}
      data-pane={BUILDER_PANE_DETAILS}
      data-active={phonePane === BUILDER_PANE_DETAILS}
      data-open={railOpen}
      data-testid="app-builder__rail"
    >
      {rail}
    </RailPane>
    <CanvasPane
      $phoneActive={phonePane === BUILDER_PANE_APP}
      data-pane={BUILDER_PANE_APP}
      data-active={phonePane === BUILDER_PANE_APP}
    >
      {canvas}
    </CanvasPane>
    <ChatPane
      $open={chatOpen}
      $phoneActive={phonePane === BUILDER_PANE_CHAT}
      data-pane={BUILDER_PANE_CHAT}
      data-active={phonePane === BUILDER_PANE_CHAT}
      data-open={chatOpen}
      data-testid="app-builder__chat"
    >
      {chat}
    </ChatPane>
  </LayoutRow>
);

export default BuilderLayout;
